module.exports = __webpack_public_path__ + "static/img/fpypos.81cb2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/fpypos.png
// module id = DwTL
// module chunks = 0